import me from "models/me";

export default function (nextState, replace, callback) {
    if (!me.isSignedInFully()) {
        const redirectPath = nextState.location.pathname + (nextState.location.search || "");
        replace({
            pathname: "/login",
            query: { redirect: redirectPath },
        });
    }
    callback();
}
